import { FC, ReactNode, createContext, useContext, useEffect, useState } from 'react';

import { breakpointsNumInPx } from 'theme/mainTheme';

type ResponsiveContextT = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isLargeDesktop: boolean;
};

type ResponsiveProviderPropsT = {
  children: ReactNode;
};

const contextDefaultValue = {
  isMobile: false,
  isTablet: false,
  isDesktop: false,
  isLargeDesktop: false,
};

const ResponsiveContext = createContext<ResponsiveContextT>(contextDefaultValue);

const getDevicesTypes = () => {
  const width = window.innerWidth || 0;

  return {
    isMobile: width < breakpointsNumInPx.md,
    isTablet: width >= breakpointsNumInPx.md && width < breakpointsNumInPx.xl,
    isDesktop: width >= breakpointsNumInPx.xl && width < breakpointsNumInPx['2xl'],
    isLargeDesktop: width >= breakpointsNumInPx['2xl'],
  };
};

const ResponsiveProvider: FC<ResponsiveProviderPropsT> = ({ children }) => {
  const [devicesTypes, setDevicesTypes] = useState(getDevicesTypes());

  /**
   * Handlers
   */
  const updateDevicesTypes = () => {
    setDevicesTypes(getDevicesTypes());
  };

  /**
   * Effects
   */
  useEffect(() => {
    window.addEventListener('resize', updateDevicesTypes);

    return () => window.removeEventListener('resize', updateDevicesTypes);
  }, []);

  return <ResponsiveContext.Provider value={devicesTypes}>{children}</ResponsiveContext.Provider>;
};

const useResponsive = () => useContext(ResponsiveContext);

export { ResponsiveProvider, useResponsive };
